import React from 'react';
import { SelectProps } from '@mui/material';
import { SelectWithOptions } from './SelectWithOptions';
import { REFERRER_OPTIONS } from '~/src/entities/welcomeForm';

export const Referrer = React.forwardRef((props: SelectProps, ref) => (
  <SelectWithOptions ref={ref} {...props} options={REFERRER_OPTIONS} />
));
